enum PublicationStatuses {
  published = "PUBLISHED",
  prePublished = "PRE_PUBLISHED",
  unpublished = "UNPUBLISHED",
  draft = "DRAFT",
}

export default PublicationStatuses;
